import * as sharedActions from './actions';

import { SharedActionTypes, SharedState } from './types';

import { ActionType } from 'typesafe-actions';
import { Reducer } from 'redux';

export type SharedAction = ActionType<typeof sharedActions>;

const initialState: SharedState = {
  // extend this with logged in user info
  currentLanguage: 'nl-BE',
  currentUser: '',
  firstName: '',
  lastName: '',
  parentPartyName: '',
  parentPartyDibCode: '',
  parentPartyId: 0,
  isUIDisabled: false,
  roles: [],
  isMobileViewSelected: false,
  useMfa: false,
  downloadLinks: {}
};

const reducer: Reducer<SharedState, SharedAction> = (state = initialState, action): SharedState => {
  switch (action.type) {
    case SharedActionTypes.SET_CURRENT_USER_INFO: {
      return { ...state,
        currentLanguage: action.payload.currentLanguage,
        currentUser: action.payload.username,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        parentPartyName: action.payload.parentPartyName,
        parentPartyDibCode: action.payload.parentPartyDibCode,
        parentPartyId: action.payload.parentPartyId,
        useMfa: action.payload.useMfa ?? false,
        roles: action.payload.roles
      };
    }
    case SharedActionTypes.TOGGLE_IS_UI_DISABLED: {
      return { ...state, isUIDisabled: action.payload };
    }
    case SharedActionTypes.SET_TOAST_MESSAGE: {
      return { ...state, toastMessage: action.payload.message };
    }
    case SharedActionTypes.SHOW_CONFIRMATION_MODAL: {
      return { ...state, confirmationModal: action.payload };
    }
    case SharedActionTypes.HIDE_CONFIRMATION_MODAL: {
      return { ...state, confirmationModal: undefined };
    }
    case SharedActionTypes.CONFIRMATION_MODAL_OK: {
      return state;
    }
    case SharedActionTypes.CONFIRMATION_MODAL_CANCEL: {
      return state;
    }
    case SharedActionTypes.SET_MOBILE_VIEW: {
      return { ...state, isMobileViewSelected: action.payload };
    }
    case SharedActionTypes.GET_DOWNLOAD_LINK_SUCCESS:
      const { amazonKey, url, filename } = action.payload;

      // Perform the state update
      const newState = {
          ...state,
          downloadLinks: {
              ...state.downloadLinks,
              [amazonKey]: url,
          },
      };

      // Trigger the download programmatically
      setTimeout(() => {
          const element = document.querySelector(`a[aria-label="Hidden link for dynamic rendering"]`) as HTMLAnchorElement;
          if (element) {
              element.href = url;
              element.download = `${filename}.pdf`; // Adjust filename logic as needed
              element.click();
          }
      }, 0); // Delay ensures the state update is finalized

      return newState;
    case SharedActionTypes.GET_DOWNLOAD_LINK_FAIL:
      return {
        ...state
      };
    default: {
      return state;
    }
  }
};

export { reducer as sharedReducer, initialState as sharedInitialState };
